export default "__VITE_ASSET__BlIJ6Xtr__"